import React from 'react'
import { SlidesControlsPropsInterface } from './types'
import Button from '@bt-react/components/Button'
import Icon, { IconType } from '@bt-react/components/Icon'
import styles from './SlidesControls.module.scss'
import classnames from 'classnames'

const SlideControls: React.FC<SlidesControlsPropsInterface> = props => {

  return <div className={styles['slides-controls']} data-bdd='slides-controls'>
    <div className={styles['slides-controls-jump-to-slide-button']}
      onClick={props.onJumpToSlidesClick}
      data-bdd='slides-controls-jump-to-slide'>
      <Icon name={IconType.iconName.items}/> Jump to slide
    </div>
    <div className={styles['slides-controls-main']}>
      <div
        data-bdd='slides-controls-back-button'
        className={classnames({
          [styles['slides-controls-navigation']]: true,
          [styles['slides-controls-navigation-disabled']]: props.backDisabled
        })}
        onClick={props.onPreviousClick}>
        <Icon name={IconType.iconName.chevronLeft} />
      </div>
      <div
        data-bdd='slides-controls-current-status'
        className={styles['slides-controls-info']}>
            Slide <span data-bdd='slides-controls-current-slide'>{props.currentSlide}</span> of <span data-bdd='slides-controls-total-slides'>{props.totalSlides}</span>
      </div>
      <div
        data-bdd='slides-controls-next-button'
        className={classnames({
          [styles['slides-controls-navigation']]: true,
          [styles['slides-controls-navigation-disabled']]: props.nextDisabled
        })}
        onClick={props.onNextClick}>
        <Icon name={IconType.iconName.chevronRight} />
      </div>
    </div>
    <Button
      data-bdd='slides-controls-end-button'
      color={IconType.colour.secondary}
      onClick={() => props.onEndClick(props.isPresenterLayoutsActive)}
      text='End slides'
      dataBdd='slides-end-btn'
    />
  </div>

}

export default SlideControls
